<!-- =========================================================================================
    File Name: FeatherIcon.vue
    Description: Feather icon component. Creates feather icon based on 'icon' prop
    Component Name: FeatherIcon
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<script>
import * as icons from 'vue-feather-icons'

export default {
    functional: true,
    name: 'feather-icon',
    props: {
        icon: { required: true },
        svgClasses: {
            type: [String, Object, Array],
            default: ''
        },
        badge: {},
        color: {
            type: String,
            default: 'primary'
        },
        filled: {
            type: Boolean,
            default: false
        },
        style: {
            type: String
        }
    },
    render(createElement, { props, data }) {
        // Add feather classes
        data.staticClass
            ? (data.staticClass = data.staticClass + ' feather-icon select-none')
            : (data.staticClass = 'feather-icon select-none')

        if (props.filled) {
            data.staticClass += ' filled'
        }

        let svg = createElement(icons[props.icon], {
            class: props.svgClasses,
            stroke: 'red'
        })
        let badgeEl = createElement(
            'span',
            {
                class: 'feather-icon-badge bg-primary text-white h-5 w-5 absolute rounded-full text-xs flex items-center justify-center',
                style: 'top: -7px; right: -5px;'
            },
            [props.badge]
        )
        let children = [svg]
        if (props.badge) {
            children.push(badgeEl)
        }
        var attrs = { style: data.style }
        var newData = { ...data, attrs }
        return createElement('span', newData, children)
    }
}
</script>

<style lang="scss">
@import '@/assets/scss/vuexy/components/featherIcon.scss';
.filled {
    svg {
        fill: currentColor;
    }
}
</style>
